import React from "react";
import { observer } from "mobx-react-lite";
import { DeleteOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { DropdownChildButton } from "src/components/buttons/DropdownChildButton";
import { SchedulingControlStore } from "../../../../SchedulingControlStore";
import styles from "./DeleteButton.module.less";

interface PropsDeleteButton {
  store: SchedulingControlStore;
}

export const DeleteButton: React.FC<PropsDeleteButton> = observer(
  ({ store }) => {
    const { selectedRows, operationLoading } = store;
    return (
      <div className={styles.button}>
        <DropdownChildButton
          disabled={!selectedRows.length}
          loading={operationLoading}
          onClick={() => store.checkDelete()}
          icon={<DeleteOutlined />}
        >
          {t("Delete selected")}
        </DropdownChildButton>
      </div>
    );
  },
);
